angular
  .module('admin')

  .factory('PMIdCache', function() {
    let cache;

    return {
      get: () => cache,
      set: value => (cache = value)
    };
  });
